import "./index.css";
import { useState, useEffect } from "react";
import { collection, getDocs, query } from "firebase/firestore";
import { db, auth } from "./firebaseConfig";
import { signOut } from "firebase/auth";

import Agenda from "./Agenda";
import Notícias from "./Noticias";
import Notificacoes from "./Notificacoes";
import Utilizadores from "./Utilizadores";
import Congresso from "./Congresso";
import BoasVindas from "./BoasVindas";
import Oradores from "./Oradores";
import Programa from "./Programa";
import Intervencoes from "./Intervencoes";
import Cores from "./Cores";
import Mapas from "./Mapas";

import PatrocinadoresOuro from "./PatrocinadoresOuro";
import PatrocinadoresPrata from "./PatrocinadoresPrata";
import PatrocinadoresPlatina from "./PatrocinadoresPlatina";
import PatrocinadoresOutros from "./PatrocinadoresOutros";

import Expositores from "./Expositores";
import InformacoesEvento from "./InformacoesEvento";
import Trabalhos from "./Trabalhos";
import Premios from "./Premios";

import { PieChart, Pie, Cell } from "recharts";

function Dashboard({ user, onLogout }) {
  const [page, setPage] = useState("inicio");
  const [mode, setMode] = useState("geral");
  const [totalUsers, setTotalUsers] = useState(0);
  const [pending, setPending] = useState(0);
  const [showPatrocinadores, setShowPatrocinadores] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const q = query(collection(db, "utilizadores"));
        const snapshot = await getDocs(q);
        const users = snapshot.docs.map((doc) => doc.data());
        setTotalUsers(users.length);
        setPending(users.filter((u) => u.status_aprovado !== true).length);
      } catch (err) {
        console.error("Erro ao buscar utilizadores:", err);
      }
    };
    fetchUsers();
  }, []);

  const PieChartWithPaddingAngle = ({ total, pending }) => {
    const approved = total - pending;
    const data = [
      { name: "Aprovados", value: approved },
      { name: "Pendentes", value: pending },
    ];
    const COLORS = ["#0f9d76", "#d68e2f"];

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ position: "relative" }}>
          <div className="pie-container">
            <PieChart width={300} height={300}>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={80}
                outerRadius={120}
                paddingAngle={5}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
            </PieChart>
          </div>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              fontWeight: 600,
              fontSize: "20px",
            }}
          >
            <div>Total</div>
            <div>{total}</div>
          </div>
        </div>

        <div style={{ marginLeft: "20px", display: "flex", flexDirection: "column" }}>
          {data.map((entry, index) => (
            <div
              key={index}
              style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
            >
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: COLORS[index % COLORS.length],
                  marginRight: "8px",
                }}
              ></div>
              <span style={{ fontWeight: 600 }}>
                {entry.name}: {entry.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  let content;
  if (mode === "geral") {
    switch (page) {
      case "inicio":
        content = <PieChartWithPaddingAngle total={totalUsers} pending={pending} />;
        break;
      case "agenda":
        content = <Agenda />;
        break;
      case "noticias":
        content = <Notícias />;
        break;
      case "notificacoes":
        content = <Notificacoes />;
        break;
      case "utilizadores":
        content = <Utilizadores />;
        break;
      case "congresso":
        setMode("congresso");
        setPage("inicio");
        content = <Congresso />;
        break;
      default:
        content = <div>Página não encontrada</div>;
    }
  } else {
    switch (page) {
      case "inicio":
        content = <Congresso />;
        break;
      case "boas-vindas":
        content = <BoasVindas />;
        break;
      case "oradores":
        content = <Oradores />;
        break;
      case "programa":
        content = <Programa />;
        break;
      case "intervencoes":
        content = <Intervencoes />;
        break;
      case "mapas":
        content = <Mapas />;
        break;
      case "expositores":
        content = <Expositores />;
        break;
      case "informacoes-evento":
        content = <InformacoesEvento />;
        break;
      case "trabalhos":
        content = <Trabalhos />;
        break;
      case "premios":
        content = <Premios />;
        break;
      case "patrocinadores-ouro":
        content = <PatrocinadoresOuro />;
        break;
      case "patrocinadores-prata":
        content = <PatrocinadoresPrata />;
        break;
      case "patrocinadores-platina":
        content = <PatrocinadoresPlatina />;
        break;
      case "patrocinadores-outros":
        content = <PatrocinadoresOutros />;
        break;
      case "voltar":
        setMode("geral");
        setPage("inicio");
        content = <PieChartWithPaddingAngle total={totalUsers} pending={pending} />;
        break;
      default:
        content = <div>Página não encontrada</div>;
    }
  }

  return (
    <div className={`dashboard ${mode === "congresso" ? "congresso" : ""}`}>
      <aside className="menu">
        <div>
          {/* LOGO SEM CONDIÇÃO, AGORA APARECE EM AMBOS */}
          <div className="logo"></div>

          <nav>
            {mode === "geral" &&
              [
                "sair",
                "utilizadores",
                "notificacoes",
                "noticias",
                "congresso",
                "agenda",
                "inicio",
              ].map((p) => {
                if (p === "sair") {
                  return (
                    <div
                      key={p}
                      className="nav-item"
                      onClick={async () => {
                        await signOut(auth);
                        onLogout();
                      }}
                    >
                      Sair
                    </div>
                  );
                } else {
                  return (
                    <a
                      key={p}
                      href="#"
                      className={`nav-item ${page === p ? "active" : ""}`}
                      onClick={() => setPage(p)}
                    >
                      {p === "congresso"
                        ? "Congresso"
                        : p === "noticias"
                        ? "Notícias"
                        : p === "notificacoes"
                        ? "Notificações"
                        : p === "agenda"
                        ? "Agenda"
                        : p === "utilizadores"
                        ? "Utilizadores"
                        : p === "inicio"
                        ? "Início"
                        : p.charAt(0).toUpperCase() + p.slice(1)}
                    </a>
                  );
                }
              })}

            {mode === "congresso" && (
              <>
                <a
                  href="#"
                  className={`nav-item ${page === "voltar" ? "active" : ""}`}
                  onClick={() => setPage("voltar")}
                >
                  Voltar
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "trabalhos" ? "active" : ""}`}
                  onClick={() => setPage("trabalhos")}
                >
                  Trabalhos
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "premios" ? "active" : ""}`}
                  onClick={() => setPage("premios")}
                >
                  Prémios
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "programa" ? "active" : ""}`}
                  onClick={() => setPage("programa")}
                >
                  Programa
                </a>

                <div className="nav-item">
                  <div
                    className="submenu-title"
                    onClick={() => setShowPatrocinadores(!showPatrocinadores)}
                  >
                    Patrocinadores
                  </div>
                  {showPatrocinadores && (
                    <div className="submenu">
                      <a
                        href="#"
                        className={`nav-item ${page === "patrocinadores-ouro" ? "active" : ""}`}
                        onClick={() => setPage("patrocinadores-ouro")}
                      >
                        Ouro
                      </a>

                      <a
                        href="#"
                        className={`nav-item ${page === "patrocinadores-prata" ? "active" : ""}`}
                        onClick={() => setPage("patrocinadores-prata")}
                      >
                        Prata
                      </a>

                      <a
                        href="#"
                        className={`nav-item ${page === "patrocinadores-platina" ? "active" : ""}`}
                        onClick={() => setPage("patrocinadores-platina")}
                      >
                        Platina
                      </a>

                      <a
                        href="#"
                        className={`nav-item ${page === "patrocinadores-outros" ? "active" : ""}`}
                        onClick={() => setPage("patrocinadores-outros")}
                      >
                        Outros
                      </a>
                    </div>
                  )}
                </div>

                <a
                  href="#"
                  className={`nav-item ${page === "oradores" ? "active" : ""}`}
                  onClick={() => setPage("oradores")}
                >
                  Oradores
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "mapas" ? "active" : ""}`}
                  onClick={() => setPage("mapas")}
                >
                  Mapas
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "intervencoes" ? "active" : ""}`}
                  onClick={() => setPage("intervencoes")}
                >
                  Intervenções
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "informacoes-evento" ? "active" : ""}`}
                  onClick={() => setPage("informacoes-evento")}
                >
                  Informações
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "expositores" ? "active" : ""}`}
                  onClick={() => setPage("expositores")}
                >
                  Expositores
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "boas-vindas" ? "active" : ""}`}
                  onClick={() => setPage("boas-vindas")}
                >
                  Boas-vindas
                </a>

                <a
                  href="#"
                  className={`nav-item ${page === "inicio" ? "active" : ""}`}
                  onClick={() => setPage("inicio")}
                >
                  Início
                </a>
              </>
            )}
          </nav>
        </div>
      </aside>

      <div className="main">
        <div className="content">{content}</div>
      </div>
    </div>
  );
}

export default Dashboard;
